









import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'

@Component
export default class Radio extends Vue {

}
